/* ///////////////////////////////////////////////////////////////////// */
/* ///////////////////////// GO TO ANCHOR ////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

const SCROLL_OPTIONS = {
  duration: 2,
  easing: (t) => 1 - Math.pow(1 - t, 6),
  offset: 0
}

/**
 * Extrae el id de ancla desde location.hash o el query ?go=
 * @returns {string} id sin '#'
 */
function getHashTarget () {
  const fromHash = (location.hash || '').replace(/^#/, '')
  if (fromHash) return fromHash

  const params = new URLSearchParams(location.search)
  return params.get('go') || ''
}

/**
 * Scroll suave hacia un ancla (Lenis si está disponible).
 * Reintenta si el nodo aún no está en el DOM (contenido post-transición).
 * @param {string} target id con o sin '#'
 * @param {{ immediate?: boolean, delay?: number, retries?: number }} [options]
 */
export function scrollToHash (target, options = {}) {
  const id = (target || '').replace(/^#/, '')
  if (!id) return

  const {
    immediate = false,
    delay = 0,
    retries = 8
  } = options

  const attempt = (remaining) => {
    const el = document.getElementById(id)
    if (!el) {
      if (remaining > 0) {
        setTimeout(() => attempt(remaining - 1), 100)
      }
      return
    }

    const selector = '#' + CSS.escape(id)

    if (window.lenisInstance) {
      window.lenisInstance.scrollTo(selector, {
        ...SCROLL_OPTIONS,
        immediate
      })
      return
    }

    el.scrollIntoView({
      behavior: immediate ? 'auto' : 'smooth',
      block: 'start'
    })
  }

  if (delay > 0) {
    setTimeout(() => attempt(retries), delay)
  } else {
    attempt(retries)
  }
}

/**
 * Lee hash / ?go= de la URL actual y hace scroll.
 * Debe llamarse DESPUÉS de que Lenis se haya (re)vinculado,
 * porque lenisScroll resetea a 0 en cada transición.
 * @param {{ delay?: number }} [options]
 */
function goTo (options = {}) {
  const target = getHashTarget()
  if (!target) return

  scrollToHash(target, {
    delay: options.delay ?? 150,
    ...options
  })
}

// Fallback: navegaciones same-document que el Navigation API no intercepta
// (canIntercept === false). Lenis anula el jump nativo del hash.
let hashListenerBound = false
function bindHashChangeFallback () {
  if (hashListenerBound) return
  hashListenerBound = true
  window.addEventListener('hashchange', () => {
    const id = (location.hash || '').replace(/^#/, '')
    if (id) scrollToHash(id, { delay: 50 })
  })
}

bindHashChangeFallback()

export default goTo
